import { ColorMode } from '@chakra-ui/react'
import { InputSize } from '@hb/shared'
import { CSSProperties } from 'react'
import { getInputSizeTokens } from './sizes'

export const baseInputPaddingX = (size: InputSize | undefined): string =>
  getInputSizeTokens(size).innerPaddingX

export const baseInputPadding = (size: InputSize | undefined): string =>
  `0 ${baseInputPaddingX(size)}`

const getInputcolor = (disabled?: boolean, colorMode?: ColorMode) => {
  if (colorMode === 'dark') return disabled ? '#718096' : '#e2e8f0'
  // Body / field text — #333 per spec Section 0.6.1.
  return disabled ? '#718096' : '#333333'
}
export const baseInputStyle = (
  size: InputSize | undefined,
  disabled?: boolean,
  colorMode?: ColorMode,
): CSSProperties => ({
  width: '100%',
  // Body/field text size is driven by the `size` knob (spec Section 0.6.2 — 12px at `md`).
  // Horizontal padding is owned by the input container, so the field itself sits flush inside it.
  fontSize: getInputSizeTokens(size).fontSize,
  // lineHeight: 'normal',
  outline: 'none',
  background: 'transparent',
  // fontFamily: 'hero-new',
  padding: 0,
  color: getInputcolor(disabled, colorMode),
})
